import { useSelector } from "react-redux"
import { Link, Navigate } from "react-router-dom"

import Button from "components/ui/button"
import { IS_JEWLR } from "helpers/application"

import Main from "./main"

const Wishlist = () => {
  const loggedIn = useSelector(
    (state) => Object.keys(state.user.jewlrorders).length > 0
  )
  const count = useSelector((state) => state.wishlist.count)

  if (IS_JEWLR() && !loggedIn) {
    return <Navigate replace to="/signup" />
  }

  return (
    <div className="contained tablet:my-64 my-32 px-16">
      <Main />
      <div className="my-48 w-full text-center">
        <Button asChild variant="secondary">
          <Link
            to={
              IS_JEWLR()
                ? loggedIn || count === 0
                  ? "/best-sellers"
                  : "/signin"
                : "/"
            }
          >
            {IS_JEWLR()
              ? loggedIn || count === 0
                ? "Shop Best Sellers"
                : "Sign In/Create Your Account"
              : "Shop Now"}
          </Link>
        </Button>
      </div>
    </div>
  )
}

export default Wishlist
